<div class="search-menu">
  <div class="search-menu__search-bar px-4 pt-4">
    <div
      class="search-menu__search-bar-input input-square items-center flex justify-end"
    >
      <span
        class="search-menu__search-bar__icon flex justify-start items-center mx-2 text-muted search-bar-icon-mobile"
      >
        <i class="pi mr-2 pi-search"></i>
      </span>
      <input
        autocomplete="off"
        #search
        name="search"
        type="text"
        pInputText
        [(ngModel)]="searchValue"
        class="search-input py-2"
        placeholder="{{ 'label.SEARCH' | translate }}"
        id="global-search"
        data-testid="global-search"
      />
      <div
        role="button"
        aria-label="clear search"
        (click)="clearSearch()"
        (keyup.enter)="clearSearch()"
        class="search-menu__search-bar__icon flex h-100 justify-start items-center mx-2 text-muted cursor-pointer"
      >
        <i class="pi mr-2 pi-times"></i>
      </div>
    </div>
  </div>
  <div
    class="search-menu__results pt-4"
    *ngIf="pinnedViews$ | async | searchMenuItems: searchValue as modules"
  >
    <div *ngIf="modules.length > 0; else emptyResult">
      <div
        class="search-menu__results-module"
        *ngFor="let module of modules; let moduleIndex = index"
      >
        <ng-container *ngIf="module.children.length > 0">
          <p class="search-menu__results-label mb-0 px-4">
            {{ module.title | propertyTranslator }}
          </p>
          <ul class="search-menu__results-menu">
            <li *ngFor="let item of module.children" role="option">
              <a
                [routerLink]="item.url"
                [routerLinkActive]="'active'"
                class="search-menu__results-item flex items-center cursor-pointer p-4"
                (click)="onItemClicked()"
                (keyup.enter)="onItemClicked()"
              >
                <span
                  class="flex justify-center items-center mx-2 item-icon"
                >
                  <i
                    class="solid-surface-text-color {{
                      item?.icon?.name || 'home' | getIconCssClass
                    }}"
                  ></i>
                </span>
                <div class="mx-4 search-menu__results-item-title">
                  <div>{{ item.title | propertyTranslator }}</div>
                </div>
              </a>
            </li>
          </ul>
        </ng-container>
      </div>
    </div>
  </div>
  <ng-template #emptyResult>
    <div class="search-menu__empty px-4" *ngIf="searchValue">
      {{ "message.NO_RESULTS_FOUND" | translate }}
    </div>
  </ng-template>
</div>
